import script from "./recordBroad.vue?vue&type=script&setup=true&lang=ts"
export * from "./recordBroad.vue?vue&type=script&setup=true&lang=ts"

import "./recordBroad.vue?vue&type=style&index=0&id=f05b66f6&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f05b66f6"]])

export default __exports__